export const ROLES = {
  admin: { label: "Admin", desc: "Akses penuh" },
  manager: { label: "Manager", desc: "Kelola service & laporan" },
  kasir: { label: "Kasir", desc: "Tambah barang & cetak nota" },
  technician: { label: "Teknisi", desc: "Kerjakan service yang di-assign" },
};

export const ROLE_ORDER = ["admin", "manager", "kasir", "technician"];

export const can = {
  createService: (role) => ["admin", "manager", "kasir"].includes(role),
  deleteService: (role) => role === "admin",
  editFinalCost: (role) => ["admin", "manager"].includes(role),
  editDiagnosis: (role) => ["admin", "manager", "technician"].includes(role),
  editAssignedTech: (role) => ["admin", "manager"].includes(role),
  viewRevenue: (role) => ["admin", "manager"].includes(role),
  viewReports: (role) => ["admin", "manager"].includes(role),
  manageUsers: (role) => role === "admin",
  manageCustomers: (role) => ["admin", "manager", "kasir"].includes(role),
  deleteCustomer: (role) => ["admin", "manager"].includes(role),
};

export const roleBadgeClass = (role) => {
  const map = {
    admin: "bg-red-50 text-red-700 border-red-200",
    manager: "bg-purple-50 text-purple-700 border-purple-200",
    kasir: "bg-blue-50 text-blue-700 border-blue-200",
    technician: "bg-emerald-50 text-emerald-700 border-emerald-200",
  };
  return map[role] || "bg-slate-100 text-slate-700 border-slate-200";
};
